<div class="message-preview">
  @if (showChannelIcon$ | async) {
    @if (latestMessageIcon$ | async; as channelIcon) {
      <mat-icon *ngIf="channelIcon !== 'internal'" class="message-preview-icon {{ channelIcon }}"></mat-icon>
    }
  }
  <span [innerHTML]="previewContent$ | async | linky"></span>
</div>
